import * as yup from 'yup';
import { ERR_ZIPCODE_FIND } from '../../../constants/response-error-messages';
import { PO_BOX_ADDRESS, COMPANY_NAME_INVALID, COMPANY_NAME_TOO_LONG, FIRST_NAME_REQUIRED, LAST_NAME_REQUIRED, SHIPPING_ADDRESS_INVALID, ZIP_CODE_REQUIRED, ZIP_CODE_INVALID, PHONE_REQUIRED, FIRST_NAME_INVALID, LAST_NAME_INVALID, FIRST_NAME_TOO_LONG, LAST_NAME_TOO_LONG, ADDRESS_NICK_NAME_INVALID, ADDRESS_NICKNAME_TOO_LONG, } from '../../../constants/field-error-messages';
import { NAME_REGEX, FIRST_LAST_NAME_REGEX, PO_BOX_ADDRESS_REGEX, COMPANY_NAME_REGEX, NON_DIGITS_REGEX, ADDRESS_REGEX, ZIPCODE_REGEX, PHONE_REGEX, } from '../../../constants/regex';
const isAddressPoBox = (address = '') => !PO_BOX_ADDRESS_REGEX.test(address);
const isMoreThanSixtyChars = (address = '') => address.length <= 60;
const isWebLink = (name = '') => !/(http|www|\.\w{2,40})/i.test(name);
const VALIDATION_TEST_NAMES = {
    FIRST_NAME_NO_WEB_LINK: 'first name cannot contain web link patterns',
    LAST_NAME_NO_WEB_LINK: 'last name cannot contain web link patterns',
    ADDRESS_NOT_PO_BOX: 'address cannot be P.O Box',
    ADDRESS_MAX_LENGTH: 'address cannot be more than 60 characters',
};
export const validationSchema = yup.object().shape({
    firstName: yup
        .string()
        .trim()
        .max(40, FIRST_NAME_TOO_LONG.message)
        .required(FIRST_NAME_REQUIRED.message)
        .matches(FIRST_LAST_NAME_REGEX, {
        message: FIRST_NAME_INVALID.message,
    })
        .test(VALIDATION_TEST_NAMES.FIRST_NAME_NO_WEB_LINK, FIRST_NAME_REQUIRED.message, isWebLink),
    nickName: yup
        .string()
        .trim()
        .max(50, ADDRESS_NICKNAME_TOO_LONG.message)
        .matches(NAME_REGEX, {
        message: ADDRESS_NICK_NAME_INVALID.message,
        excludeEmptyString: true,
    }),
    lastName: yup
        .string()
        .trim()
        .max(60, LAST_NAME_TOO_LONG.message)
        .required(LAST_NAME_REQUIRED.message)
        .matches(FIRST_LAST_NAME_REGEX, {
        message: LAST_NAME_INVALID.message,
    })
        .test(VALIDATION_TEST_NAMES.LAST_NAME_NO_WEB_LINK, LAST_NAME_REQUIRED.message, isWebLink),
    companyName: yup
        .string()
        .trim()
        .max(100, COMPANY_NAME_TOO_LONG.message)
        .matches(COMPANY_NAME_REGEX, {
        message: COMPANY_NAME_INVALID.message,
        excludeEmptyString: true,
    }),
    addressLine1: yup
        .string()
        .trim()
        .required(SHIPPING_ADDRESS_INVALID.message)
        .matches(ADDRESS_REGEX, { message: SHIPPING_ADDRESS_INVALID.message })
        .test(VALIDATION_TEST_NAMES.ADDRESS_NOT_PO_BOX, PO_BOX_ADDRESS.message, isAddressPoBox)
        .test(VALIDATION_TEST_NAMES.ADDRESS_MAX_LENGTH, SHIPPING_ADDRESS_INVALID.message, isMoreThanSixtyChars),
    addressLine2: yup
        .string()
        .trim()
        .matches(ADDRESS_REGEX, {
        message: SHIPPING_ADDRESS_INVALID.message,
        excludeEmptyString: true,
    })
        .test(VALIDATION_TEST_NAMES.ADDRESS_MAX_LENGTH, SHIPPING_ADDRESS_INVALID.message, isMoreThanSixtyChars),
    zipCode: yup
        .string()
        .when('isZipCodeNotFoundError', {
        is: true,
        then: yup
            .string()
            .matches(NON_DIGITS_REGEX, { message: ZIP_CODE_INVALID.message }),
    })
        .when('isZipCodeApiError', {
        is: true,
        then: yup
            .string()
            .matches(NON_DIGITS_REGEX, { message: ERR_ZIPCODE_FIND.message }),
    })
        .required(ZIP_CODE_REQUIRED.message)
        .matches(ZIPCODE_REGEX, { message: ZIP_CODE_INVALID.message }),
    isZipCodePending: yup.boolean(),
    isZipCodeApiError: yup.boolean(),
    primaryPhone: yup
        .string()
        .required(PHONE_REQUIRED.message)
        .matches(PHONE_REGEX, { message: PHONE_REQUIRED.message }),
    alternatePhone: yup.string().matches(PHONE_REGEX, {
        message: PHONE_REQUIRED.message,
        excludeEmptyString: true,
    }),
});
